/* eslint-disable camelcase */
import React from 'react';
import PropTypes from 'prop-types';
import '../../card_block/Card';

function MentorItem(props) {
  const { mentor } = props;

  const {
    attributes,
  } = mentor;

  const {
    designation, advertisement_headline, introduction, company_name,
  } = attributes;

  return (
    <li
      key={company_name}
    >
      <div className="card_home">
        <div className="card_home-content">
          Designation:
          {' '}
          {designation}
        </div>
        <div className="card_home-content">
          Advertisement Headline:
          {' '}
          {advertisement_headline}
        </div>
        <div className="card_home-content">
          Introduction:
          {' '}
          {introduction}
        </div>
        <div className="card_home-content">
          Company Name:
          {' '}
          {company_name}
        </div>
      </div>
    </li>
  );
}
export default MentorItem;

MentorItem.propTypes = {
  mentor:
    PropTypes.objectOf(
      {
        designation: PropTypes.string.isRequired,
        advertisement_headline: PropTypes.string.isRequired,
        introduction: PropTypes.string.isRequired,
        company_name: PropTypes.string.isRequired,
      },
    ).isRequired,
};
